import { View, Text } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { useTranslations } from "@src/packages/i18n";
import GlassScreenLayout from "@louise/moon-ui/primitives/GlassScreenLayout";
import { SCREEN_PADDING_TOP } from "@louise/moon-ui/theme/tokens";
import { BackLink } from "@louise/moon-ui";
import { EMBER } from "../../onboarding/theme";

export default function RegionGatePlaceholder() {
  const navigation = useNavigation();
  const t = useTranslations();

  return (
    <GlassScreenLayout>
      <View
        style={{
          flex: 1,
          paddingHorizontal: 16,
          paddingTop: SCREEN_PADDING_TOP,
        }}
      >
        <BackLink
          label="Costs"
          action="region_gate_back"
          onPress={() => navigation.goBack()}
        />

        <View
          style={{
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            paddingHorizontal: 24,
          }}
        >
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 20,
              fontWeight: "600",
              color: EMBER.colors.text,
              textAlign: "center",
              marginBottom: 12,
            }}
          >
            {t("region_gate.not_available_in_region")}
          </Text>
          <Text
            className="font-dm-sans"
            style={{
              fontSize: 15,
              color: EMBER.colors.textLight,
              textAlign: "center",
              lineHeight: 22,
              maxWidth: 320,
            }}
          >
            {t("region_gate.us_only_coming_soon")}
          </Text>
        </View>
      </View>
    </GlassScreenLayout>
  );
}
